<div class="custom-tooltip">
  {{tooltipLabel}}
  <span [ngStyle]="{'width': width}" [class]="class">{{tooltipText}}</span>
</div>
